module.exports = __webpack_public_path__ + "img/07.614e5605.jpg";